import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterDataService {
  constructor() {}
  private selectedFilter: any ;
  set(filter){
    this.selectedFilter = filter;
  }
  get(){
    return this.selectedFilter;
  }
}
